<template>
  <v-layout column>
    <v-layout
      column
      class="pa-4"
    >
      <pending-application
        class="mb-4"
        v-for="application in filteredPendingApplications"
        :key="application.id"
        :application="application"
        :personalTypeIcon="personalTypeIcon(application)"
        :processCpfCnpj="processCpfCnpj(application.person)"
      />

      <waiting-to-be-sent-application
        class="mb-4"
        v-for="application in filteredWaitingToBeSentApplications"
        :key="application.id"
        :application="application"
        :personalTypeIcon="personalTypeIcon(application)"
        :processCpfCnpj="processCpfCnpj(application.person)"
      />

      <application-in-review
        class="mb-4"
        v-for="application in filteredInReviewApplications"
        :key="application.id"
        :application="application"
        :personalTypeIcon="personalTypeIcon(application)"
        :processCpfCnpj="processCpfCnpj(application.person)"
      />

      <approved-application
        class="mb-4"
        v-for="application in filteredApprovedApplications"
        :key="application.id"
        :application="application"
        :personalTypeIcon="personalTypeIcon(application)"
        :processCpfCnpj="processCpfCnpj(application.person)"
      />
    </v-layout>
    <!-- Empty Content for Admin -->
    <v-card height="490" v-if="applications.length === 0 && isAdmin">
      <v-layout
        class="empty-list"
        justify-center
        align-center
        column
        fill-height
      >
        <img
          class="mb-3 icon"
          src="@/assets/image/icon/mailbox.svg"
          alt="Ícone de Caixa Postal"
          width="320"
        />
        <h1 class="heading">Nenhum requerimento para análise</h1>
      </v-layout>
    </v-card>

    <!-- Empty Content for Entrepeneur -->
    <v-card height="490" v-if="showEmptyContentComponent">
      <v-card-text>
        <v-layout
          class="empty-list"
          justify-center
          align-center
          column
          fill-height>
          <img
            class="mb-3 icon"
            src="@/assets/image/icon/leaf.svg"
            alt="Ícone Ambiental"
            width="320">
          <div v-if="applications.length === 0">
            <h1 class="heading">Você já pode fazer seus requerimentos</h1>
            <p class="grey--text">Clique no botão abaixo e inicie agora.</p>
            <v-btn v-if="!isAdmin" color="primary" @click="newApplication()">
              <v-icon left>mdi-plus-circle-outline</v-icon>
              <span class="text">Novo Requerimento</span>
            </v-btn>
          </div>
          <h1 class="heading" v-else>Não existem requerimentos</h1>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import CPF_CNPJ from 'cpf_cnpj';
import ApplicationInReview from '@/components/application/list/ApplicationInReview';
import ApprovedApplication from '@/components/application/list/approved_application/ApprovedApplication';
import PendingApplication from '@/components/application/list/PendingApplication';
import WaitingToBeSentApplication from '@/components/application/list/WaitingToBeSentApplication';

export default {
  name: 'Applications',
  components: {
    ApplicationInReview,
    ApprovedApplication,
    PendingApplication,
    WaitingToBeSentApplication,
  },
  props: {
    applications: {
      type: Array,
      default: () => [],
    },
    activeStatus: {
      type: String,
      default: 'all',
    },
    totalPages: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    newApplication() {
      this.$router.push('novo');
    },
    showApplication(application) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${application.id}/visualizar`);
    },
    personalTypeIcon(application) {
      return application.person.person_type === 'physical_person' ? 'mdi-account' : 'mdi-domain';
    },
    processCpfCnpj(person) {
      if (person.person_type === 'physical_person') {
        return `CPF: ${CPF_CNPJ.CPF.format(person.cpf_cnpj)}`;
      }
      return `CNPJ: ${CPF_CNPJ.CNPJ.format(person.cpf_cnpj)}`;
    },
  },
  computed: {
    isAdmin() {
      return this.$router.currentRoute.meta.userAlias === 'admin';
    },
    showEmptyContentComponent() {
      const activeStatusApplications = this.applications.filter(application =>
          this.activeStatus === 'all' || application.status === this.activeStatus,
      );
      return (this.applications.length === 0 /* || activeStatusApplications.length === 0*/)
          // ticket: 1269: Não entendemos o porque de não mostrar o conteúdo vazio quando
          // não há requerimentos em um status específico
          && !this.isAdmin;
    },
    filteredPendingApplications() {
      return this.applications.filter(pending => {
        return 'pending' === pending.status;
      });
    },
    filteredWaitingToBeSentApplications() {
      return this.applications.filter(waitingToBeSent => {
        return 'waiting_to_be_sent' === waitingToBeSent.status;
      });
    },
    filteredApprovedApplications() {
      return this.applications.filter(approved => {
        return 'done' === approved.status;
      });
    },
    filteredInReviewApplications() {
      return this.applications.filter(inReview => {
        return 'waiting_for_review' === inReview.status || 'in_review' === inReview.status;
      });
    },
  },

};
</script>

<style>
</style>
